<template>
  <div id="fundo-cinza">
    <v-toolbar class="primary elevation-0 small-extension" dark>
      <h1 class="titulo">Relatórios</h1>
    </v-toolbar>
    <v-tabs centered dark>
      <v-tabs-bar slot="activators">
        <v-tabs-slider class="secondary"></v-tabs-slider>
        <v-tabs-item v-for="(tab, i) in tabs" :key="i" :to="tab.to">{{ tab.title }}</v-tabs-item>
      </v-tabs-bar>
    </v-tabs>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    updated () {
      this.redirectFromRoot()
    },
    created () {
      this.redirectFromRoot()
    },
    data () {
      return {
        tabAtiva: '',
        tabs: [
          { title: 'Histórico por data', to: { name: 'RelatoriosHistoricoData' } },
          { title: 'Histórico por usuário', to: { name: 'RelatoriosHistoricoUsuario' } },
          { title: 'Comparativos', to: { name: 'RelatoriosComparativos' } },
          { title: 'Pagamentos', to: { name: 'RelatoriosPagamentos' } }
        ]
      }
    },
    methods: {
      redirectFromRoot () {
        if (this.$route.name === 'RelatoriosRoot') {
          this.$router.push({ name: 'RelatoriosHistoricoData' })
        }
      }
    }
  }
</script>

<style>
  #fundo-cinza { background: #EAEAEA; min-height: calc(100vh - 78px); }
</style>



// WEBPACK FOOTER //
// RelatoriosRoot.vue?7bbf527d